import Secondary from '../layouts/Secondary'
import About from '../views/About'
import Referral from '../views/Referral'
import Contact from '../views/Contact'
import FAQ from '../views/FAQ'
import PrivacyPolicy from '../views/PrivacyPolicy'
import TermAndConditions from '../views/TermAndConditions'
import InvestForm from '../views/form/invest'
import BorrowForm from '../views/form/borrow'
import PurchasingForm from '../views/purchasing/form'
import PawnForm from '../views/pawn/form'
import Profile from '../views/user/Profile'
import ResetPassword from '../views/user/setting/ResetPassword'
import VerifyCode from '../views/user/verify'
import NewLoan from '../views/form/NewLoan'
import InputPhoneNumber from '../views/user/InputPhoneNumber'
import InfoPage from '../components/InfoPage.vue'
import LoanDetail from '../views/user/LoanDetail'

export const secondaryPagesRouter = {
  path: '',
  name: 'secondary',
  component: Secondary,
  redirect: '/about',
  children: [
    {
      path: '/about',
      name: 'about',
      component: About
    },
    {
      path: '/referral',
      name: 'referral',
      component: Referral
    },
    {
      path: '/contact',
      name: 'contact',
      component: Contact
    },
    {
      path: '/faq',
      name: 'faq',
      component: FAQ
    },
    {
      path: '/privacy-policy',
      name: 'privacy-policy',
      component: PrivacyPolicy
    },
    {
      path: '/term-and-conditions',
      name: 'term-and-conditions',
      component: TermAndConditions
    },
    {
      path: '/invest-form',
      name: 'invest-form',
      component: InvestForm
    },
    {
      path: '/forms/:formType/borrow-form',
      name: 'borrow-form',
      component: BorrowForm
    },
    {
      path: '/forms/:formType/purchasing',
      name: 'purchasing-form',
      component: PurchasingForm
    },
    {
      path: '/forms/:formType/pawn',
      name: 'pawn-form',
      component: PawnForm
    },
    {
      path: '/profile',
      name: 'profile',
      component: Profile,
      props: true
    },
    {
      path: '/loan-detail/:loan_id',
      name: 'loan-detail',
      component: LoanDetail,
      props: true
    },
    {
      path: '/user-setting/reset-password',
      name: 'reset-password',
      component: ResetPassword,
      props: true
    },
    {
      path: '/verify-code/:uuid',
      name: 'verity-code',
      component: VerifyCode,
      props: true
    },
    {
      path: '/new-loan',
      name: 'new-loan',
      component: NewLoan,
      props: true
    },
    {
      path: '/input-phone-number',
      name: 'input-phone-number',
      component: InputPhoneNumber,
      props: true
    },
    {
      path: '/message',
      name: 'info-page',
      component: InfoPage,
      props: true
    }
  ]
}
